export const isValidLink = (link: string) => {
  try {
    new URL(link);
    return true;
  } catch (error) {
    return false;
  }
};

export const phoneRules = [
  {
    pattern: /^[+]?[\d()\-\s]+$/,
    message: 'Please enter a valid phone number',
  },
];
